import { css } from '@emotion/react';

export default $ => css`
  .jedi-form {
    background-color: transparent !important;

    .card {
      background-color: transparent;
      border-radius: 0px;
      border: 0px;
    }

    .card-body {
      padding-left: 0px !important;
    }

    .field .form-group:not(.field-array),
    .rjsf-field .form-group:not(.rjsf-field-array) {
      display: flex;
    }

    .rjsf-field .form-group .form-group {
      display: contents;
    }

    label.control-label {
      font-size: 14px;
      color: #2c00a6;
      font-weight: bold;
      width: 16.666667% !important;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji',
        'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
    }

    .btn {
      box-sizing: border-box;
      margin: 0;
      font-family: inherit;
      overflow: visible;
      text-transform: none;
      -webkit-appearance: button;
      display: inline-block;
      font-weight: 400;
      text-align: center;
      vertical-align: middle;
      user-select: none;
      border: 1px solid transparent;
      padding: 0.375rem 0.75rem;
      font-size: 1rem;
      line-height: 1.5;
      border-radius: 0.25rem;
      transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
      cursor: pointer;
      margin-top: 10px;
      margin-right: 5px;

      /* Emulating \`@each\` loop in SCSS using JavaScript */
      ${Object.entries($.jediColors ?? []).map(
        ([name, clmap]) => `
          &.btn-${name} {
            color: ${clmap.fg};
            background-color: ${clmap.bg};
            border-color: ${clmap.border};

            &:hover {
              color: ${clmap.fg};
              background-color: ${clmap.hoverBg};
              border-color: ${clmap.hoverBorder};
            }
          }
        `
      )}
    }
  }
`;
